import { HttpResponseStatusCodes } from '@hobt/constants';
import { ApiClient, ApiClientConfig } from 'Foundation/Api';
import { AuthenticationContextType } from 'Foundation/Authentication';
import { config } from '../../../../../../../../config';
import { MasterPoolRemarkPayload, ValidationRemarkPayload } from '../types';

type getLoansStatusPayload = {
  loans: string[];
  validateOnly: boolean;
  targetStatus?: string;
  masterPoolCmhcAccountNumber?: string;
};

export type overrideLoanStatusPayload = getLoansStatusPayload & {
  remark: {
    remarkId: number;
    remarkText: string;
  };
};

type RequestPropsTableData = {
  authenticationContext: AuthenticationContextType;
  payload: MasterPoolRemarkPayload;
  requestQuery?: string;
};

const apiClientConfig: ApiClientConfig = {
  timeout: config.validationReviewInventoryApi.requestTimeout
};

const timeout: number = config.validationReviewInventoryApi.requestTimeout;

const loansUrl: string = config.validationReviewInventoryApi.urls.loanInventoryTabDetails;

export const getLoansStatus = async ({
  authenticationContext,
  payload,
  requestQuery = `${loansUrl}/loans/status-update`
}: RequestPropsTableData): Promise<[]> => {
  try {
    const response = await ApiClient(authenticationContext, apiClientConfig).postWithAuth(
      requestQuery,
      payload,
      { timeout: timeout }
    );
    return (
      ((response?.data?.statusCode === HttpResponseStatusCodes.Created ||
        response?.data?.statusCode === HttpResponseStatusCodes.OK) &&
        response?.data?.data) ||
      []
    );
  } catch (err) {
    throw new Error('Error adding loans');
  }
};

type RequestProps = {
  authenticationContext: AuthenticationContextType;
  payload: overrideLoanStatusPayload;
  requestQuery?: string;
};

interface OverideLoanStatusRequest {
  authenticationContext: AuthenticationContextType;
  payload: OverideLoanStatus;
  requestQuery?: string;
}
interface ValidationOverideLoanStatusRequest {
  authenticationContext: AuthenticationContextType;
  payload: ValidationRemarkPayload;
  requestQuery?: string;
}
export interface OverideLoanStatus {
  poolprecitiontypecode?: string;
  validateOnly?: boolean;
  targetStatus?: string;
  portfolioIds?: number[];
  applicationId?: number;
  cmhcAccountNumbers?: string[];
  lenderReferenceNumbers?: string[];
  decisionOverrideRationaleId?: number;
  decisionOverrideRemarks?: string;
  loans?: string[];
  masterPoolCmhcAccountNumber?: string;
  remark?: {
    remarkId: number;
    remarkText: string;
  };
}

export const overrideLoanStatuses = async ({
  authenticationContext,
  payload,
  requestQuery = `${loansUrl}/loans/status-update`
}: RequestProps): Promise<[]> => {
  try {
    const response = await ApiClient(authenticationContext, apiClientConfig).postWithAuth(
      requestQuery,
      payload,
      { timeout }
    );

    return (
      ((response?.data?.statusCode === HttpResponseStatusCodes.Created ||
        response?.data?.statusCode === HttpResponseStatusCodes.OK) &&
        response?.data?.data) ||
      []
    );
  } catch (err) {
    console.log(err);
    throw new Error('Error overriding loans');
  }
};

export const overrideLoanStatus = async ({
  authenticationContext,
  payload,
  requestQuery = `${loansUrl}/loans/status-update`
}: OverideLoanStatusRequest): Promise<[]> => {
  try {
    const response = await ApiClient(authenticationContext, apiClientConfig).postWithAuth(
      requestQuery,
      payload,
      { timeout }
    );

    return (
      ((response?.data?.statusCode === HttpResponseStatusCodes.Created ||
        response?.data?.statusCode === HttpResponseStatusCodes.OK) &&
        response?.data?.data) ||
      []
    );
  } catch (err) {
    console.log(err);
    throw new Error('Error overriding loans');
  }
};

export const validateOverrideLoanStatus = async ({
  authenticationContext,
  payload,
  requestQuery = `${loansUrl}/loans/status-update`
}: ValidationOverideLoanStatusRequest): Promise<[]> => {
  try {
    const response = await ApiClient(authenticationContext, apiClientConfig).postWithAuth(
      requestQuery,
      payload,
      { timeout }
    );

    return (
      ((response?.data?.statusCode === HttpResponseStatusCodes.Created ||
        response?.data?.statusCode === HttpResponseStatusCodes.OK) &&
        response?.data?.data) ||
      []
    );
  } catch (err) {
    throw new Error('Error overriding loans');
  }
};
